import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFileOpen = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 52,
	height: 52,
	viewBox: "0 0 52 52",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.4218 10.5H8C5.79086 10.5 4 12.2909 4 14.5V38.4298C4 40.639 5.79086 42.4298 8 42.4298H39.5789C41.7881 42.4298 43.5789 40.639 43.5789 38.4298V17.4801C43.5789 15.271 41.7881 13.4801 39.579 13.4801H17.5317C16.3384 13.4801 15.2115 12.9305 14.4768 11.9901C13.7421 11.0496 12.6152 10.5 11.4218 10.5Z",
		fill: "#DFE3EA"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.0756 22.272L6.76206 37.079C5.82689 39.685 7.75828 42.4301 10.527 42.4301H40.656C42.3221 42.4301 43.8138 41.3973 44.4001 39.8377L49.9667 25.0306C50.95 22.4151 49.0168 19.623 46.2226 19.623H15.8406C14.1523 19.623 12.6459 20.683 12.0756 22.272Z",
		fill: "#EDF0F4"
	})]
});
export default SvgIconFileOpen;
